export default __webpack_public_path__ + "static/media/strikethrough.cc5501bb.svg";